import { Skeleton } from '@/components/ui/Skeleton';

export function SearchResultSkeleton() {
  return (
    <div className="py-6 -mx-3 px-3">
      <Skeleton className="h-4 w-16 mb-3" />
      <Skeleton className="h-5 w-full mb-2" />
      <Skeleton className="h-5 w-5/6 mb-4" />
      <Skeleton className="h-7 w-3/4" />
    </div>
  );
}
